import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import Dialog from 'src/components/design-system/Dialog';
import useAutoFocus from 'src/hooks/useAutoFocus';

interface EmailNotificationsConfirmDialogProps {
  open: boolean;
  width?: string;
  onSaveAndContinue: () => void;
  onDiscardChanges: () => void;
  onCancel: () => void;
}

const EmailNotificationsConfirmDialog = ({
  open,
  width = '725px',
  onSaveAndContinue,
  onDiscardChanges,
  onCancel,
}: EmailNotificationsConfirmDialogProps) => {
  const { t } = useTranslation();
  const title = t('Unsaved Changes');
  const content = t('unsavedNotificationTogglesMessage');
  const saveButtonText = t('saveAndContinue');
  const discardButtonText = t('discardChanges');
  const cancelButtonText = t('Cancel');
  const cancelButtonRef = useAutoFocus(open, [open, title, content]);

  return (
    <Dialog
      width={width}
      open={open}
      onClose={onCancel}
      title={title}
      className="email-notification-confirm"
      id="email-notification-confirm"
    >
      {content}
      <DialogActionsBar>
        <div className="flex justify-end gap-2">
          <Button color="info" onClick={onSaveAndContinue}>
            {saveButtonText}
          </Button>
          <Button color="info" onClick={onDiscardChanges}>
            {discardButtonText}
          </Button>
          <Button color="info" ref={cancelButtonRef} onClick={onCancel}>
            {cancelButtonText}
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default EmailNotificationsConfirmDialog;
